import React, { Fragment } from 'react';
import { notification, Button, message } from 'antd';
import { getData } from '@util';
import { API_GET_DOWNLOAD_FILE } from '@api';
import { hasAttach, getTaskStatus } from './util';

const OpenNotification = (item, history) => {
  const { id, taskName, taskResult, taskParam, taskMessage, taskAttach, taskData, sysCode } = item;
  let taskAttachArr = [],
    taskParamObj = {};
  try {
    taskAttachArr = taskAttach ? JSON.parse(taskAttach) : [];
    taskParamObj = taskParam ? JSON.parse(taskParam) : {};
  } catch (error) {
    // window.console.log(error)
  }
  //const taskAttachArr = taskAttach ?JSON.parse(taskAttach):[]
  //const taskParamObj = taskParam ? JSON.parse(taskParam) :{}
  const attachFlag = hasAttach(taskAttach);
  const { isImport } = taskParamObj; //判断是否是导入
  const key = `${id}${taskResult}`; //保证唯一索引
  const duration = 5;
  const config = {
    key,
    duration,
    style: { width: 330 },
    placement: 'bottomRight',
  };
  //关闭按钮的回调
  const close = (key, timer) => {
    notification.close(key);
    clearInterval(timer);
  };
  //点击确定按钮跳转到指定页面
  const goTo = (key, timer) => {
    close(key, timer);
    if (taskParamObj && taskParamObj.returnPath) {
      history.push('/sell/404');
      setTimeout(() => {
        history.push(`/sell${taskParamObj.returnPath}`);
      }, 0);
    } else {
      message.error('跳转失败');
    }
  };
  //点击立即下载按钮 下载对应文件
  const downLoad = (taskAttachArr, key, timer) => {
    if (taskAttachArr && taskAttachArr.length) {
      const { name, url } = taskAttachArr[0];
      const searchParams = { name, url };
      getData({ api: API_GET_DOWNLOAD_FILE, searchParams });
    } else {
      message.error('尴尬了，下载地址不见了');
    }
    close(key, timer);
  };
  //成功的提示
  const successBtns = (key, timer) => (
    <Fragment>
      <Button
        style={{ marginRight: 4 }}
        type="default"
        size="small"
        onClick={() => {
          close(key, timer);
        }}>
        稍后
      </Button>
      <Button
        type="primary"
        size="small"
        onClick={() => {
          isImport ? goTo(key, timer) : downLoad(taskAttachArr, key, timer);
        }}>
        {isImport ? '立即前往' : '立即下载'}
      </Button>
    </Fragment>
  );
  //失败的提示
  const failBtns = (key, timer) =>
    isImport ? (
      <Fragment>
        <Button
          style={{ marginRight: 4 }}
          type="default"
          size="small"
          onClick={() => {
            close(key, timer);
          }}>
          稍后
        </Button>
        {/* <Button type="primary" size="small" onClick={() => {
          exportError(taskAttachArr, key, timer)
        }}>导出报错信息</Button> */}
      </Fragment>
    ) : (
      <Button
        type="primary"
        size="small"
        onClick={() => {
          close(key, timer);
        }}>
        知道了
      </Button>
    );
  //知道了按钮
  const iKnow = (key, timer) => (
    <Button
      type="primary"
      size="small"
      onClick={() => {
        close(key, timer);
      }}>
      知道了
    </Button>
  );

  if (taskResult === 1) {
    let timeOut = 3;
    //const description = <div><span style={{color: 'red'}}>{timeOut}</span>秒后自动关闭</div>,
    const timer = setInterval(() => {
      if (timeOut > 0) {
        timeOut -= 1;
        notification.info({
          message: `${taskName}执行中`,
          description: (
            <div>
              {/*<span style={{ color: "red" }}>{timeOut}</span>*/}
              {/*秒后自动关闭*/}
            </div>
          ),
          btn: iKnow(key, timer),
          onClose: () => close(key, timer),
          ...config,
        });
      } else {
        close(key, timer);
      }
    }, 1000);
  }

  if (taskResult === 2) {
    let timeOut = duration;
    const taskStatus = getTaskStatus(taskData);
    let notificationMethod = 'success';
    if (taskStatus === 1) {
      notificationMethod = 'error';
    }
    // TODO:
    // 企业购的导入逻辑不要导入成功的提示
    // 用户中心的导入要成功的提示

    // 企业购
    const isCSMS = sysCode === 'CSMS';
    const timer = setInterval(() => {
      if (timeOut > 0) {
        timeOut -= 1;
        isCSMS && !attachFlag
          ? null
          : notification[notificationMethod]({
              message: `${taskName}执行${taskStatus === 1 ? '失败' : '成功'}`,
              description: (
                <div>
                  {attachFlag ? '是否立即下载 ?' : null}
                  {/*<span style={{ color: "red" }}>{timeOut}</span>*/}
                  {/*秒后自动关闭*/}
                  {/*<br />*/}
                </div>
              ),
              btn: attachFlag ? successBtns(key, timer) : null,
              onClose: () => close(key, timer),
              ...config,
            });
      } else {
        close(key, timer);
      }
    }, 1000);
  }

  if (taskResult === 3) {
    let timeOut = duration;
    //const description = <div><span style={{color: 'red'}}>{taskMessage}</span><br/>{isImport ? '是否导出报错信息 ?' : ''}</div>
    const timer = setInterval(() => {
      if (timeOut > 0) {
        timeOut -= 1;
        notification.error({
          message: `${taskName}执行失败`,
          description: (
            <div>
              <span style={{ color: 'red' }}>{taskMessage}</span>
              <br />
              {isImport ? '是否导出报错信息 ?' : ''}
              {/*<span style={{ color: "red" }}>{timeOut}</span>*/}
              {/*秒后自动关闭*/}
            </div>
          ),
          btn: failBtns(key, timer),
          onClose: () => close(key, timer),
          ...config,
        });
      } else {
        close(key, timer);
      }
    }, 1000);
  }
};
export default OpenNotification;
